/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Support_TextInputs */

const en_login_offline_support_text = /** @type {(inputs: Login_Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please contact support if you have any issues: support@closedcaptioncreator.com`)
};

const fr_login_offline_support_text = /** @type {(inputs: Login_Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez contacter le support si vous rencontrez des problèmes : support@closedcaptioncreator.com`)
};

const de_login_offline_support_text = /** @type {(inputs: Login_Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Problemen wenden Sie sich bitte an den Support: support@closedcaptioncreator.com`)
};

const it_login_offline_support_text = /** @type {(inputs: Login_Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In caso di problemi, contattare l'assistenza: support@closedcaptioncreator.com`)
};

const ru_login_offline_support_text = /** @type {(inputs: Login_Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В случае возникновения проблем, пожалуйста, свяжитесь со службой поддержки по адресу: support@closedcaptioncreator.com`)
};

const es_login_offline_support_text = /** @type {(inputs: Login_Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comuníquese con el soporte si tiene algún problema: support@closedcaptioncreator.com`)
};

const zh_cn2_login_offline_support_text = /** @type {(inputs: Login_Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如有任何问题，请联系客服：support@closedcaptioncreator.com`)
};

const ja_login_offline_support_text = /** @type {(inputs: Login_Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何か問題がございましたら、サポートまでご連絡ください: support@closedcaptioncreator.com`)
};

const hi_login_offline_support_text = /** @type {(inputs: Login_Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि आपको कोई समस्या हो तो कृपया सहायता टीम से संपर्क करें: support@closedcaptioncreator.com`)
};

const pt_pt2_login_offline_support_text = /** @type {(inputs: Login_Offline_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso tenha algum problema, entre em contato com o suporte: support@closedcaptioncreator.com`)
};

/**
* | output |
* | --- |
* | "Please contact support if you have any issues: support@closedcaptioncreator.com" |
*
* @param {Login_Offline_Support_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_support_text = /** @type {((inputs?: Login_Offline_Support_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Support_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_support_text(inputs)
	if (locale === "de") return de_login_offline_support_text(inputs)
	if (locale === "it") return it_login_offline_support_text(inputs)
	if (locale === "ru") return ru_login_offline_support_text(inputs)
	if (locale === "es") return es_login_offline_support_text(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_support_text(inputs)
	if (locale === "ja") return ja_login_offline_support_text(inputs)
	if (locale === "hi") return hi_login_offline_support_text(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_support_text(inputs)
	return en_login_offline_support_text(inputs)
});